import React from "react";
import banner from "../../assets/01_Home/HYUNDAIKONA_17.webp";

/*eslint-disable */

declare const window: any;
const BannerComponent: React.FC = () => {
  return (
    <div
      className="banner-pqr-component"
      style={{ backgroundImage: `url(${banner})` }}
    >
      <div className="mascara-banner-pqr-component">Contáctanos</div>
    </div>
  );
};

export default BannerComponent;
